import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

const CLASSROOM_HOST = /(^|\.)((room\.sh)|(thelessonspace\.com))$/;

@Component({
  selector: 'app-classroom-frame',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      min-height: 0;
      min-width: 0;
    }

    iframe {
      flex: 1 1 auto;
      width: 100%;
      min-height: 0;
      border: 0;
    }
  `,
  template: `
    @if (safeUrl(); as src) {
      <iframe
        [src]="src"
        title="Therapy classroom"
        allow="camera; microphone; display-capture; autoplay; fullscreen"
      ></iframe>
    }
  `,
})
export class ClassroomFrameComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly url = input.required<string>();

  protected readonly safeUrl = computed<SafeResourceUrl | null>(() => {
    let parsed: URL;
    try {
      parsed = new URL(this.url());
    } catch {
      return null;
    }
    if (parsed.protocol !== 'https:' || !CLASSROOM_HOST.test(parsed.hostname)) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(parsed.toString());
  });
}
